module.exports = __webpack_public_path__ + "static/media/homepage.d151ce61.jpg";